/**
 * BathIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const BathIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M22 10h-2V6a4 4 0 0 0-8 0 1 1 0 1 0 2 0 2 2 0 1 1 4 0v4H2a1 1 0 1 0 0 2v2a6 6 0 0 0 2.84 5.09l-.73 1.46a1 1 0 0 0 .44 1.34A.93.93 0 0 0 5 22a1 1 0 0 0 .89-.55l.8-1.6Q7.337 20 8 20h8q.663 0 1.31-.15l.8 1.6A1 1 0 0 0 19 22a.93.93 0 0 0 .45-.11 1 1 0 0 0 .44-1.34l-.73-1.46A6 6 0 0 0 22 14v-2a1 1 0 1 0 0-2m-2 4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4v-2h16z" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const BathIcon = makeIcon('BathIcon', BathIconSvg)
